import LoadingHomeSkeleton from 'components/shared/loading-home-skeleton'
import SuspendedSimCard from 'components/shared/suspended-sim-card'
import { TitleSection } from 'components/shared/title-section'
import useTranslation from 'next-translate/useTranslation'
import BoxEmptySimulations from './box-empty-sim'
import SeeAllButton from './see-all-button'

interface SuspendedSimulationsSectionProps {
    loading?: boolean
    suspendedSimulations?: Simulation[]
    setIndexTab: (tab: number) => void
}

const SuspendedSimulationsSection = (props: SuspendedSimulationsSectionProps) => {
    const { t } = useTranslation('simulation')
    return (
        <div>
            <TitleSection
                loading={props.loading}
                title={t('suspendedSection.title')}
                subtitle={t('suspendedSection.description')}
            />
            <div className="w-full">
                {props.suspendedSimulations && props.suspendedSimulations.length <= 0 && !props.loading ? (
                    <BoxEmptySimulations
                        title={t('emptyState.suspended.title')}
                        subtitle={t('emptyState.suspended.description')}
                    />
                ) : (
                    <div className="flex flex-col w-full">
                        <div className="flex flex-col sm:flex-row  gap-2">
                            {props.loading ? (
                                <LoadingHomeSkeleton />
                            ) : (
                                <div className="w-full grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 gap-3">
                                    {' '}
                                    {props.suspendedSimulations
                                        ?.map((sim) => {
                                            return (
                                                <div key={sim._id} className="w-full">
                                                    <SuspendedSimCard key={sim._id} simulation={sim} />
                                                </div>
                                            )
                                        })
                                        .slice(0, 3)}
                                </div>
                            )}
                        </div>

                        <SeeAllButton onClick={() => props.setIndexTab(3)} loading={props.loading} />
                    </div>
                )}
            </div>
        </div>
    )
}

export default SuspendedSimulationsSection
